'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _utils = require('helpers/utils');

var _components2 = require('components');

var _payment = require('redux/actions/payment');

var _personal = require('redux/actions/personal');

var _modal = require('redux/actions/modal');

var _modal_type = require('redux/actions/modal_type');

var _auth = require('redux/actions/auth');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _utils2 = require('./utils');

var orderUtils = _interopRequireWildcard(_utils2);

var _addresses = require('redux/actions/addresses');

var _windowOrGlobal = require('window-or-global');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CreateOrder: {
        displayName: 'CreateOrder'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Order/CreateOrder.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var CreateOrder = _wrapComponent('CreateOrder')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState,
            params = _ref.params,
            location = _ref.location;

        var pipoId = getState().setting.pipoOnlineShopId;

        var _getState = getState(),
            user = _getState.auth.user;

        var promise = [];
        if (user) {
            var id = parseInt(params.order_id, 10);

            promise = [dispatch((0, _personal.getPersonalOrderDetail)(id)), dispatch((0, _payment.getPayment)()), dispatch((0, _payment.getPaymentsParamsFromPIPObyId)(pipoId)), dispatch((0, _auth.load)()), dispatch((0, _addresses.loadAddresses)())];
        }
        return _promise2.default.all(promise);
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        address: state.address,
        payments: orderUtils.mergePaymentParameters(state.payment.list, state.payment.pipoList),
        order: state.personal_order_detail.order,
        user: state.auth.user,
        setting: state.setting,
        preload: state.personal_order_detail.preload,
        preloadPay: state.payment.preload,
        turnstileCaptcha: state.setting.turnstileCaptcha,
        turnstileCaptchaSitekey: state.setting.turnstileCaptchaSitekey,
        lang: state.lang
    };
}, { push: _reactRouterRedux.push, setPaymentId: _payment.setPaymentId, addAddress: _addresses.addAddress, showModal: _modal.showModal, hide: _modal.hide, setOrder: _personal.setOrder, showModalAuth: _modal_type.showModalAuth }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(CreateOrder, _Component);

    function CreateOrder(props, context) {
        (0, _classCallCheck3.default)(this, CreateOrder);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CreateOrder.__proto__ || (0, _getPrototypeOf2.default)(CreateOrder)).call(this, props, context));

        _this.handleAddressAdd = function (address) {
            _this.props.addAddress(address.address).then(function () {
                return _reactSAlert2.default.success(_this.props.lang['store.common.addresses.added'], { position: 'top-right', effect: 'slide', timeout: 5000 });
            });
        };

        _this.onPay = function () {
            var lang = _this.props.lang;

            var captcha = void 0;
            if (_this.props.turnstileCaptcha) {
                captcha = turnstile.getResponse();
                if (captcha == undefined || captcha == null) {
                    var alertMessage = _this.props.lang['user.errorInvalidCaptcha'];
                    setTimeout(function () {
                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                    }, 0);
                    return null;
                }
            }

            var access_token = _LocalStorageProxy2.default.getItem('ibonus.access_token') || null,
                refresh_token = _LocalStorageProxy2.default.getItem('ibonus.refresh_token') || null;

            // проверяем авторизацию поьзователя
            if (_this.props.user && access_token && refresh_token) {
                if (_this.props.payments.length === 0) {
                    _this.props.showModal({
                        title: lang['store.create_order.order_payment'],
                        content: _react3.default.createElement(
                            'div',
                            null,
                            lang['store.create_order.order_payment_error.first'],
                            '.',
                            _react3.default.createElement('br', null),
                            lang['store.create_order.order_payment_error.second'],
                            '.',
                            _react3.default.createElement('br', null),
                            lang['store.create_order.order_payment_error.third'],
                            '.'
                        ),
                        modalType: 'order_create'
                    });
                } else {
                    if (_this.props.order.sum < 1) {
                        var _alertMessage = (0, _utils.replaceCharToArrayIndex)(_this.props.lang['error.pipo.operationInvalidMinimalSum'], [_this.props.lang.code]);
                        setTimeout(function () {
                            _reactSAlert2.default.error(_alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                        }, 0);
                        return null;
                    }
                    _LocalStorageProxy2.default.setItem('shared_coupons', '');
                    _this.setState({ preload: true });
                    _this._onPay({
                        clientCommentary: _this.state.comment,
                        delivery_address: _this.state.deliveryAddress,
                        discountSum: _this.state.bonusValue,
                        couponId: _this.state.couponId,
                        couponToken: _this.state.couponToken,
                        customerCouponId: _this.state.customerCouponId,
                        preloadCallback: _this.onPreloadState,
                        customFields: _this.state.customFields,
                        childOrders: _this.state.childOrdersAdditional,
                        captcha: captcha
                    });
                }
            } else {
                _this.props.showModalAuth(lang);
            }
        };

        _this.onPreloadState = function () {
            _this.setState({ preload: false });
        };

        _this.onChangeInput = function (e) {
            _this.setState({ comment: e.target.value });
        };

        _this.onDeliveryAddressChange = function (e) {
            _this.setState({ deliveryAddress: e.target.value });
        };

        _this.onChangeBonusValue = function (e) {
            _this.setState({ bonusValue: e.target.value });
        };

        _this.couponSelect = function (coupon) {
            var lang = _this.props.lang;

            if (coupon.id === _this.state.couponId) {
                _this.setState({ couponId: null });
                _this.setState({ couponToken: null });
                _this.setState({ customerCouponId: null });
                _this.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.productsCurrent));
                _this.props.order.sum = _this.props.order.sumCurrent;
            } else {
                var useCoupon = false;
                _this.props.order.products.forEach(function (item) {
                    if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id && item.isCoupon !== true) {
                        useCoupon = true;
                    }
                });
                if (!useCoupon) {
                    var modalContent = _react3.default.createElement(
                        'div',
                        { className: 'row no-margin' },
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            lang['store.useCoupon.popup.confirmation.p1'],
                            ' ',
                            coupon.offer.name,
                            ' ',
                            lang['store.useCoupon.popup.confirmation.p2']
                        )
                    );

                    _this.props.showModal({
                        title: lang['store.useCoupon.popup.title'],
                        content: modalContent,
                        titleSuccess: lang['store.common.yes'],
                        titleClose: lang['store.common.no'],
                        onSuccess: function onSuccess() {
                            _this.props.order.sum = _this.props.order.sumCurrent;
                            _this.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.productsCurrent));
                            _this.props.order.products.push({
                                id: coupon.id,
                                isCoupon: true,
                                quantity: 1, price: 0, base_price: 0,
                                modifier_option_id: coupon.modifier_option_id,
                                modifiedOption: coupon.modifiedOption,
                                offer: coupon.offer
                            });
                            _this.setState({ couponId: coupon.id });
                            _this.setState({ couponToken: coupon.token });
                            _this.setState({ customerCouponId: coupon.customer_coupon_id });
                        },
                        modalType: 'del'
                    });
                } else {
                    _this.props.order.sum = _this.props.order.sumCurrent;
                    _this.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.productsCurrent));
                    _this.props.order.products.forEach(function (item) {
                        if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id) {
                            if (item.quantity === 1) {
                                _this.props.order.sum = _this.props.order.sum - item.base_price;
                                item.price = 0;
                                item.base_price = 0;
                                item.isCoupon = true;
                            } else {
                                item.quantity = item.quantity - 1;
                                _this.props.order.sum = _this.props.order.sum - item.base_price;
                                _this.props.order.products.push({
                                    id: coupon.id,
                                    isCoupon: true,
                                    quantity: 1,
                                    price: 0,
                                    base_price: 0,
                                    modifier_option_id: coupon.modifier_option_id,
                                    modifiedOption: coupon.modifiedOption,
                                    offer: coupon.offer
                                });
                            }
                            _this.setState({ couponId: coupon.id });
                            _this.setState({ couponToken: coupon.token });
                            _this.setState({ customerCouponId: coupon.customer_coupon_id });
                        }
                    });
                }
            }
        };

        _this.changeCustomFields = function (e) {
            if (_this.state.customFields[e.target.id].type === 'text') {
                _this.state.customFields[e.target.id].value = e.target.value;
            } else {
                _this.state.customFields[e.target.id].value = e.target.checked;
            }
            _this.setState({ customFields: _this.state.customFields });
        };

        _this.onSuccessCaptcha = function (value) {
            _this.setState({ captcha: value });
        };

        _this.showCaptcha = function () {
            if (_this.props.turnstileCaptcha) {
                return _react3.default.createElement('div', {
                    id: 'myWidgetTurnstile',
                    className: 'cf-turnstile',
                    'data-sitekey': _this.props.turnstileCaptchaSitekey,
                    'data-callback': _this.onSuccessCaptcha
                });
            }
            return '';
        };

        _this.renderCaptcha = function () {
            if (_this.props.turnstileCaptcha) {
                setTimeout(function () {
                    if (_this.state.renderCaptcha) {
                        var elm = document.getElementById('myWidgetTurnstile');
                        turnstile.render(elm, {
                            sitekey: _this.props.turnstileCaptchaSitekey
                        });
                        _this.setState({ renderCaptcha: false });
                    }
                }, 1500);
            }
            return '';
        };

        var order = props.order || {};
        if (!order.id) {
            // если заказ не найден
            _reactSAlert2.default.error(props.lang['error.orderNotFind'], { position: 'top-right', effect: 'slide', timeout: 3000 });
            props.push('/personal/order-list'); // редиректим на "список заказов"
        } else {
            var AccountsList = props.user.amount[0];
            var discountSum = props.order.sum / 2;
            var addAmount = 0;
            if (order.discount_sum > 0) {
                discountSum = order.discount_sum * 1;
                addAmount = order.discount_sum * 1;
            }
            if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
                discountSum = AccountsList.amount * 1 + addAmount;
            }
            if (AccountsList.amount == 0 || props.order.sum <= 1) {
                discountSum = 0;
            }
            if (props.order.sum - discountSum < 1) {
                discountSum = props.order.sum - 1;
                if (discountSum < 0) discountSum = 0;
            }
            discountSum = Math.floor(discountSum);
            var defaultAddressString = null;
            if (props.setting.deliveryFieldShow === true) {
                var defaultAddress = (props.address.list || []).find(function (address) {
                    return address.is_default;
                });
                defaultAddressString = (defaultAddress || {}).address;
            }
            var bonusValue = discountSum;
            var customFields = [];
            if (order.ibonus_data !== null) {
                var IBonusData = _windowOrGlobal.JSON.parse(order.ibonus_data);
                bonusValue = 0;
                if (IBonusData.discount_sum) {
                    bonusValue = IBonusData.discount_sum * 1;
                }
                if (IBonusData.custom_fields !== undefined && IBonusData.custom_fields !== null) {
                    customFields = IBonusData.custom_fields;
                }
            } else if (order.discount_sum > 0) {
                bonusValue = 0;
            }
            var childOrders = {};
            if (order.childOrders) {
                order.childOrders.forEach(function (item) {
                    childOrders[item.id] = {
                        id: item.id,
                        comment: item.client_comment,
                        deliveryAddress: item.delivery_address
                    };
                    childOrders[item.id].onAddressChangeChildOrder = function (e) {
                        var orderId = item.id;
                        _this._onAddressChangeByChildOrders(orderId, e.target.value);
                    };
                    childOrders[item.id].onCommentChangeChildOrder = function (e) {
                        var orderId = item.id;
                        _this._onCommentChangeByChildOrders(orderId, e.target.value);
                    };
                });
            }

            _this.state = {
                comment: '',
                failError: '',
                bonusValue: bonusValue,
                couponId: null,
                couponToken: null,
                customerCouponId: null,
                deliveryAddress: defaultAddressString,
                preload: false,
                customFields: customFields,
                childOrdersAdditional: childOrders,
                renderCaptcha: true,
                widgetId: null
            };
            if (_this.props.order.client_comment) {
                _this.state.comment = _this.props.order.client_comment;
            }

            _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.products));
            _this.props.order.sumCurrent = _this.props.order.sum;
            if (_this.props.order.delivery_address) {
                _this.state.deliveryAddress = _this.props.order.delivery_address;
            }
            var useCoupon = false;
            var couponProduct = null;
            _this.props.order.productsCurrent.forEach(function (item) {
                if (item.is_coupon === true) {
                    useCoupon = true;
                    couponProduct = item;
                }
            });
            if (useCoupon) {
                var productsCurrent = _this.props.order.products.filter(function (item) {
                    return item.id !== couponProduct.id;
                });
                _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(productsCurrent));
                var changeCount = false;
                _this.props.order.productsCurrent.forEach(function (item) {
                    if (item.offer.id === couponProduct.offer.id && item.modifier_option_id === couponProduct.modifier_option_id && item.is_coupon !== true && item.isCoupon !== true) {
                        changeCount = true;
                        item.quantity++;
                        _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
                    }
                });
                if (!changeCount) {
                    couponProduct.price = couponProduct.offer.price;
                    couponProduct.base_price = couponProduct.offer.price;
                    _this.props.order.productsCurrent.push(couponProduct);
                    _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
                }
                _this.props.user.coupons.forEach(function (item) {
                    if (item.offer_id === couponProduct.offer_id && item.modifier_option_id === couponProduct.modifier_option_id) {
                        _this.state.couponId = item.id;
                    }
                });
            }
        }
        _this._onPay = function () {};
        return _this;
    }

    (0, _createClass3.default)(CreateOrder, [{
        key: '_onAddressChangeByChildOrders',
        value: function _onAddressChangeByChildOrders(orderId, address) {
            this.state.childOrdersAdditional[orderId].deliveryAddress = address;
            this.setState({ customFields: this.state.customFields });
        }
    }, {
        key: '_onCommentChangeByChildOrders',
        value: function _onCommentChangeByChildOrders(orderId, comment) {
            this.state.childOrdersAdditional[orderId].comment = comment;
            this.setState({ customFields: this.state.customFields });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.address[0]) this.setState({ deliveryAddress: this.props.address[0] });
            if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error')) {
                this.setState({ complite: false, failError: this.props.location.query.error });
            } else if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error_message')) {
                this.setState({ complite: false, failError: this.props.location.query.error_message });
            } else if (this.props.location.query.hasOwnProperty('fail')) {
                this.setState({ complite: false, failError: 'При оплате произошла ошибка.' });
            }
        }
    }, {
        key: '_getPriceSaleWithIBonusDiscount',
        value: function _getPriceSaleWithIBonusDiscount(product) {
            var discount_to_product = this._getIbonusDiscountToProduct(product);
            if (discount_to_product <= 0) {
                return Number(product.base_price);
            }
            return Number(product.base_price) - discount_to_product;
        }
    }, {
        key: '_getIbonusDiscountToProduct',
        value: function _getIbonusDiscountToProduct(product) {
            if (this.state.bonusValue) {
                var orderSum = this.props.order.sum;
                var discountPercent = this.state.bonusValue / (orderSum / 100);
                var bonusDiscountToProduct = product.base_price * (discountPercent / 100);
                return bonusDiscountToProduct;
            }
            return 0;
        }
    }, {
        key: 'callbackCaptcha',
        value: function callbackCaptcha(token) {
            this.setState({ captcha: token });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.order == null) {
                return null;
            }
            if (!this.props.user) {
                return null;
            }
            var _props$order = this.props.order,
                _props$order$products = _props$order.products,
                products = _props$order$products === undefined ? [] : _props$order$products,
                sum = _props$order.sum;

            if (sum - this.state.bonusValue < 0 || this.state.bonusValue < 0) {
                this.setState({ bonusValue: 0 });
                this.state.bonusValue = 0;
            }
            var sumDiscount = this.props.order.discount_sum * 1;
            if (sum > 0) {
                var AccountsList = this.props.user.amount[0];

                var discountSum = sum / 2;
                var addAmount = 0;
                if (this.props.order.discount_sum > 0) {
                    addAmount = this.props.order.discount_sum * 1;
                }
                if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
                    discountSum = AccountsList.amount * 1 + addAmount;
                }
                if (sum - discountSum < 1) {
                    discountSum = sum - 1;
                    if (discountSum < 0) discountSum = 0;
                }
                discountSum = Math.floor(discountSum);
                if (this.state.bonusValue > discountSum) {
                    this.setState({ bonusValue: discountSum });
                    this.state.bonusValue = discountSum;
                }
                if (this.props.order.ibonus_data !== null) {
                    var IBonusData = _windowOrGlobal.JSON.parse(this.props.order.ibonus_data);
                    if (IBonusData.discount_sum) {
                        sumDiscount = this.props.order.discount_sum * 1 - IBonusData.discount_sum * 1;
                    }
                    // if (IBonusData.custom_fields !== undefined && IBonusData.custom_fields !== null) {
                    //     this.props.customFields = IBonusData.custom_fields;
                    // }
                }
                sumDiscount = 0;
                this.props.order.products.forEach(function (product) {
                    var discountPerPiece = _this2.props.order.orderDiscounts.reduce(function (discountPerPiece, discount) {
                        var isAdd = product.productDiscounts.find(function (productDiscount) {
                            return productDiscount.discount_id === discount.discount_id;
                        });
                        if (!isAdd) {
                            product.productDiscounts.push(discount);
                        }
                        var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
                        var result = discountPerPiece + sum;
                        return +result;
                    }, 0);
                    // Сделаем общий метод пробежки по массиву и пересчитаем общую сумму со всеми скидками сразу
                    if (product.productDiscounts.length) {
                        discountPerPiece = product.productDiscounts.reduce(function (discountPerPiece, discount) {
                            var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
                            var result = discountPerPiece + sum;
                            return +result;
                        }, 0);
                    }
                    product.discountPerPiece = discountPerPiece;
                    sumDiscount += discountPerPiece * product.quantity;
                    product.additionalInfo = product.additional_info ? _windowOrGlobal.JSON.parse(product.additional_info) : null;
                    if (product.additionalInfo && product.additionalInfo.custom_fields) {
                        product.custom_fields = product.additionalInfo.custom_fields;
                    }
                });
            }
            if (this.props.payments.length === 0) {
                return _react3.default.createElement(
                    _components2.Preloader,
                    { preload: this.props.preload || this.props.preloadPay || this.state.preload },
                    _react3.default.createElement(_components2.OrderItems, {
                        onAddAddress: this.handleAddressAdd,
                        addressOptions: this.props.address.list,
                        comment: this.state.comment,
                        setting: this.props.setting,
                        products: products,
                        sum: sum,
                        failError: this.state.failError,
                        onChangeInput: this.onChangeInput,
                        onPay: this.onPay,
                        couponSelect: this.couponSelect,
                        couponId: this.state.couponId,
                        user: this.props.user,
                        bonusValue: this.state.bonusValue,
                        sumDiscount: sumDiscount,
                        ibonus_data: this.props.order.ibonus_data,
                        order_type_id: this.props.order.type_id,
                        childOrders: this.props.order.childOrders,
                        childOrdersAdditional: this.state.childOrdersAdditional,
                        paymentInId: this.props.order.payment_in_id,
                        onChangeBonusValue: this.onChangeBonusValue,
                        before: _react3.default.createElement(_components2.OrderSteps, { step: '2' }),
                        deliveryAddress: this.state.deliveryAddress,
                        onDeliveryAddressChange: this.onDeliveryAddressChange,
                        customFields: this.state.customFields,
                        changeCustomFields: this.changeCustomFields,
                        showCaptcha: this.showCaptcha,
                        renderCaptcha: this.renderCaptcha
                    })
                );
            }

            var disButton = function disButton() {
                var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                _this2.setState({ disabled: !slug });
            };

            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload || this.props.preloadPay || this.state.preload },
                _react3.default.createElement(_components2.OrderItems, {
                    onAddAddress: this.handleAddressAdd,
                    addressOptions: this.props.address.list,
                    comment: this.state.comment,
                    setting: this.props.setting,
                    products: products,
                    sum: sum,
                    onChangeInput: this.onChangeInput,
                    onPay: this.onPay,
                    couponSelect: this.couponSelect,
                    couponId: this.state.couponId,
                    user: this.props.user,
                    bonusValue: this.state.bonusValue,
                    sumDiscount: sumDiscount,
                    ibonus_data: this.props.order.ibonus_data,
                    order_type_id: this.props.order.type_id,
                    childOrders: this.props.order.childOrders,
                    childOrdersAdditional: this.state.childOrdersAdditional,
                    paymentInId: this.props.order.payment_in_id,
                    onChangeBonusValue: this.onChangeBonusValue,
                    before: _react3.default.createElement(_components2.OrderSteps, { step: '2' }),
                    disabled: this.state.disabled,
                    failError: this.state.failError,
                    paymentList: _react3.default.createElement(_components2.PaymentList, {
                        disButton: disButton,
                        payments: this.props.payments,
                        order: this.props.order,
                        getInstance: function getInstance(PaymentListComponent) {
                            _this2._onPay = PaymentListComponent.onPay;
                        }
                    }),
                    deliveryAddress: this.state.deliveryAddress,
                    onDeliveryAddressChange: this.onDeliveryAddressChange,
                    customFields: this.state.customFields,
                    changeCustomFields: this.changeCustomFields,
                    showCaptcha: this.showCaptcha,
                    renderCaptcha: this.renderCaptcha
                })
            );
        }
    }]);
    return CreateOrder;
}(_react2.Component), _class2.propTypes = {
    order: _react2.PropTypes.object,
    payments: _react2.PropTypes.array,
    showModal: _react2.PropTypes.func,
    hide: _react2.PropTypes.func,
    user: _react2.PropTypes.any,
    showModalAuth: _react2.PropTypes.func,
    setting: _react2.PropTypes.object.isRequired,
    push: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object,
    preload: _react2.PropTypes.bool
}, _temp)) || _class) || _class));

exports.default = CreateOrder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Order/CreateOrder.jsx
// module id = 1820
// module chunks = 0